import { flatten } from "flat";

export default flatten({
  auth: {
    signup:
      "Join CBB-NOW today for <b>FREE</b>  and grow your business by expanding your current operation lines with affordable micro-financing.",
    resetPasswordInstructions:
      "Instructions for resetting your password have been sent to your email",
    resetPasswordSuccess:
      "Password successfully updated. You'll be redirected to the login page in a moment.",
    resetPasswordError:
      "We encountered an issue while trying to reset your password. Please try again.",
  },
  landingPage: {
    hero: {
      primary: "Landing Page Catchphrase",
      secondary: "A subtitle that tells a little more about our product",
      action: "Sign Up",
    },
    badges: [
      {
        primary: "Plan",
        secondary: "Search for something great. Without commitment.",
      },
      {
        primary: "Share",
        secondary: "Use our platform to share your lines and get feedback.",
      },
      {
        primary: "Request",
        secondary:
          "Our breeze simple onboarding system will help you fill out some forms.",
      },
      {
        primary: "Trade",
        secondary:
          "Trade with confidence knowing CBB will expand your business.",
      },
    ],
  },
});
